import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from "react-intl";
import moment from 'moment';
import { useRealtimeUnits } from 'Core/hooks';
//Enuns
import { TypeObjectMap, TypeLayer } from 'Components/Map/providers/enums';

import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';

//Components
import { Timezone } from '../../../../../../../components/uiControls'
import { IconButton } from '@gpstrackit/gtc-react-controls';
import { ExportButton } from 'Components/Table/Toolbar';
import ColorSelector from 'Components/ColorSelector';
import { ToggleSwitch } from 'Components';
import useExport from 'Components/Table/Export';
import { Grid, Typography } from '@mui/material';
import { GetFormatForMoment } from 'Core/data/Helpers';
import { Tooltip } from "@gpstrackit/gtc-react-controls";
//Actions
import { selectModuleMapSettings, getVehicleTrails, setVehicleTrailToPrint, updateShowVehicleTrailsTable } from 'Redux/actions';
import { vicinityToolSetField } from '../../redux/slice';

import { getFormattedDateByTimeZone } from '../../../../../../../core/data/Helpers';

//Enums
import { MapUtilitiesTypes } from '../../../MapUtilitiesMenu/enums';

//Styles
import './style.scss'

const VicinityToolUnits = (props) => {
    const { mapRef, deleteObject, addObjects, generateSvgIcon, addShape } = props;
    const dispatch = useDispatch();
    const { messages } = useIntl();

    //Redux States
    const { result } = useSelector(state => state.realtimeMapsVicinityTool);
    const isKph = useSelector((state) => state.securityRedux.user.isKph);
    const locale = useSelector(state => state.commomRedux.language);
    const units = useRealtimeUnits({ trackFields: ['id', 'label', 'timeZone', 'useEcuSpeed'] });
    const lang = useSelector(state => state.commomRedux.language);

    const { user: { dateformat, timeZone } } = useSelector((state) => state.securityRedux);


    const changeColorPolyLine = (id, color, show) => {
        if (!show) return

        const polyline = mapRef.current.getObject(TypeObjectMap.Polyline, `${id}-polyline`);
        if (polyline) {
            polyline.instance.setOptions({
                strokeColor: color,
                fillColor: color
            });
        }

        const startMarker = mapRef.current.getObject(TypeObjectMap.Marker, `${id}-marker-1`);
        const endMarker = mapRef.current.getObject(TypeObjectMap.Marker, `${id}-marker-2`);

        const svgIcon = generateSvgIcon(color)

        startMarker.instance.setIcon(svgIcon)
        endMarker.instance.setIcon(svgIcon)
    }

    const getHeaders = () => {
        return [
            "Unit",
            messages['realtimemaps_vicinitytool_firtsevent'],
            messages['realtimemaps_vicinitytool_lastevent'],
            messages['realtimemaps_vicinitytool_eventsinside'],
            messages['realtimemaps_vicinitytool_behaviorevents']
        ]
    }

    const getDataToExport = () => {
        let newDataToExport = [];
        const items = result

        items.forEach((item) => {
            let unit = units.find((unit) => unit?.id === +item.unitId)
            let timeZoneUnit = unit?.timeZone?.name
            let currentFormat = GetFormatForMoment(dateformat)
            let events = ["Rapid Acceleration", "Hard Brake", "Hard Turn", "Potencial Incident"]
            let behaviorEvents = searchBehaviorEvents(item?.events || [], events)

            let firtEventDate = item.events.length ? getFormattedDateByTimeZone(item.events[0].unitTime, timeZoneUnit || timeZone || "UTC", messages, `${currentFormat} hh:mm:ss a`, false, lang) : null
            let lastEventDate = item.events.length ? getFormattedDateByTimeZone(item.events[item.events.length - 1].unitTime, timeZoneUnit || timeZone || "UTC", messages, `${currentFormat} hh:mm:ss a`, false, lang) : null
            const unitLabel = item?.unitLabel || ""
            const eventsInside = item.eventsInside || "0"
            newDataToExport.push([unitLabel, firtEventDate, lastEventDate, eventsInside, behaviorEvents || "0"]);
        });

        return newDataToExport;
    };

    const exportCSVPdf = useExport(
        getHeaders,
        getDataToExport,
        [],
        [],
        null,
        messages['realtimemaps_vicinitytool_vicinity_tool'],
        'landscape',
        true
    );

    const onExport = (type) => {
        if (type === "CSV") exportCSVPdf.exportCSV();
        else exportCSVPdf.exportPDF();
    }

    const searchBehaviorEvents = (array, events) => {
        const filteredRecords = array.filter(item => events.includes(item.eventName));
        return filteredRecords.length || 0;
    }

    return (
        <div>
            <div style={{ paddingTop: 5 }}>
                <ExportButton onExport={onExport} />
            </div>
            <div style={{ padding: 0, height: '67vh', overflow: 'auto', paddingRight: 6 }}>
                {
                    result.map((item, index) => {
                        let firtEvent = item.events.length ? item.events[0].unitTime : null
                        let lastEvent = item.events.length ? item.events[item.events.length - 1].unitTime : null
                        let extraData = units.find((unit) => unit?.id === +item.unitId)
                        let timeZoneUnit = extraData?.timeZone?.name

                        if (!extraData) {
                            extraData = {
                                label: item?.unitLabel,
                                timeZone: {
                                    name: timeZone
                                }
                            }
                        }

                        let events = ["Rapid Acceleration", "Hard Brake", "Hard Turn", "Potencial Incident"]
                        let behaviorEvents = searchBehaviorEvents(item?.events || [], events)
                        return (
                            <div className="vicinity-tool-card" key={item?.unitId}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 5 }}>
                                    <Tooltip title={item?.unitLabel}>
                                        <Typography
                                            noWrap
                                            variant="subtitle1"
                                            style={{ fontSize: 16, fontWeight: 600, width: 160 }}
                                        >
                                            {item?.unitLabel}
                                        </Typography>
                                    </Tooltip>

                                    <div style={{ display: 'flex', alignItems: 'center', width: 130, justifyContent: 'space-between' }}>
                                        <div style={{ width: 50, height: 30 }}>
                                            {
                                                item.show && (
                                                    <ColorSelector
                                                        id={`vc-tool-color-${index}`}
                                                        color={item?.color}
                                                        disavl
                                                        onHandeChange={(value) => {
                                                            let currentResult = result.map(unit => ({ ...unit }));
                                                            const indexUnit = currentResult.findIndex(unit => unit.unitId === item.unitId);
                                                            if (indexUnit !== -1) {
                                                                currentResult[indexUnit].color = `${value.color}`
                                                                changeColorPolyLine(`vicinity-tool-${index}`, value.color, item?.show)
                                                                dispatch(vicinityToolSetField({ result: currentResult }))
                                                            }
                                                        }}
                                                    />
                                                )
                                            }
                                        </div>
                                        <div className="vicinity-tool-switch">
                                            <ToggleSwitch
                                                id={`vc-tool-switch-${index}`}
                                                medium
                                                blueToggle
                                                checked={item.show}
                                                onChange={(checked) => {
                                                    let currentResult = result.map(unit => ({ ...unit }));
                                                    const indexUnit = currentResult.findIndex(unit => unit.unitId === item.unitId);
                                                    if (indexUnit !== -1) {
                                                        currentResult[indexUnit].show = checked
                                                        dispatch(vicinityToolSetField({ result: currentResult }))
                                                        if (checked) {
                                                            addObjects(`vicinity-tool-${index}`, item.events, item.color)
                                                        } else {
                                                            deleteObject(index)
                                                        }
                                                    }
                                                }}
                                                optionLabels={[messages['show'], messages['hide']]}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"

                                >
                                    <Grid item xs zeroMinWidth>
                                        <div style={{ display: 'flex', flexWrap: 'nowrap', marginTop: 5 }}>
                                            {messages['realtimemaps_vicinitytool_firtsevent']}: {" "}
                                            <InsertInvitationIcon style={{ color: 'gray', padding: 2, fontSize: 18 }} />
                                            <Timezone
                                                date={new Date(firtEvent)}
                                                dateFormat={dateformat}
                                                timeFormat="hh:mm:ss a"
                                                timezone={timeZoneUnit || timeZone || "UTC"}
                                                className="vicinity-tool-date"
                                                customFormat={true}
                                                locale={locale}
                                                noWrap={false}
                                                oneControl={true}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                >
                                    <Grid item xs zeroMinWidth>
                                        <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
                                            {messages['realtimemaps_vicinitytool_lastevent']}: {" "}
                                            <InsertInvitationIcon style={{ color: 'gray', padding: 2, fontSize: 18 }} />
                                            <Timezone
                                                date={new Date(lastEvent)}
                                                dateFormat={dateformat}
                                                timeFormat="hh:mm:ss a"
                                                timezone={timeZoneUnit || timeZone}
                                                className="vicinity-tool-date"
                                                customFormat={true}
                                                locale={locale}
                                                noWrap={false}
                                                oneControl={true}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>

                                <span>{messages['realtimemaps_vicinitytool_eventsinside']}: {item.eventsInside}</span>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>{messages['realtimemaps_vicinitytool_behaviorevents']}: {behaviorEvents}</span>
                                    <IconButton
                                        variant={"secondary"}
                                        isDisabled={false}
                                        icon="arrow_forward_ios_icon"
                                        style={{ fontSize: 22, color: '#212121', marginTop: -10 }}
                                        tooltip={messages['realtimemaps_vicinitytool_venicle_trails']}
                                        onClick={(e) => {
                                            if (e) e.preventDefault();

                                            const paramToGetTrails = {
                                                unitId: item.unitId,
                                                event: '0',
                                                startDate: moment.utc(firtEvent).format(),
                                                endDate: moment.utc(lastEvent).format(),
                                                limit: 100,
                                                offset: 0,
                                                useEcuSpeed: extraData?.useEcuSpeed,
                                                kph: isKph
                                            }

                                            dispatch(selectModuleMapSettings(MapUtilitiesTypes.VehicleTrails));
                                            dispatch(updateShowVehicleTrailsTable(true));
                                            dispatch(getVehicleTrails(paramToGetTrails));
                                            dispatch(setVehicleTrailToPrint(extraData));
                                            mapRef?.current?.removeLayer(TypeLayer.VicinityTool);

                                            addShape("mapObject_02", "mapObject_03")
                                        }}
                                    />
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default VicinityToolUnits